"use strict";

module.exports = [0, '4px', '8px', '16px', '32px', '64px'];
//# sourceMappingURL=space.js.map